<!--
 * @Author: Gaho
 * @Date: 2024-04-18 14:21:55
 * @LastEditors: Gaho
 * @LastEditTime: 2024-04-19 15:39:50
 * @Description: 
-->
<template>
    <CasinoHistoryHeaderCell
        :text="t.USER.toUpperCase()"
        class="md:flex-[0.6] sm:flex-[1]"
    />
    <CasinoHistoryHeaderCell 
        :text="t.Multiplier.toUpperCase()" 
        class="sm:flex-[1] md:flex-[0.6]"
    />
    <CasinoHistoryHeaderCell
        :text="t.Bets.toUpperCase()"
        class="md:flex-[0.6] sm:flex-[1]"
    />
</template>
<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';

const t = useTranslation();
const props = defineProps({
    isMobileMode: Boolean, // 声明出来，否则控制台一直打印 warn 信息 
});

</script>
